import React, { useState, useEffect } from "react";
import ProductoInicio from "../components/products/ProductoInicio";
import { Carousel } from "react-bootstrap";
import { dbApp } from "../firebase/config";

const Inicio = () => {
  const [sliderImages, setsliderImages] = useState({});
  const [mostrarSlider, setMostrarSlider] = useState(false);

  useEffect(() => {
    getSlider();
  }, []);

  const getSlider = () => {
    console.log("Cargando...");
    setMostrarSlider(false);
    dbApp
      .collection("slider")
      .where("negocio", "==", "1")
      .get()
      .then((response) => {
        response.forEach((doc) => {
          const slider = doc.data();
          slider.id = doc.id;
          setsliderImages(slider);
          setMostrarSlider(true);
        });
      });
  };

  let mostrar;
  if (!mostrarSlider) {
    mostrar = (
      <Carousel.Item>
        <img src="https://via.placeholder.com/1200X300" alt="Hola" />
      </Carousel.Item>
    );
  }

  return (
    <>
      <Carousel className="border" style={{ cursor: "pointer" }}>
        {mostrarSlider
          ? sliderImages.images.map((slideUrl, index) => (
              <Carousel.Item
                key={index}
                style={{ height: "300px" }}
                onClick={() => console.log("object")}
              >
                <img
                  src={slideUrl}
                  alt="Slider Inicio"
                  className="w-100 h-100"
                />
              </Carousel.Item>
            ))
          : mostrar}
      </Carousel>

      <ProductoInicio />
    </>
  );
};

export default Inicio;
